 export const generateMiniChart = (data: number[]) => {
   const width = 300;
   const height = 60;
   const padding = 10;
 
   const max = Math.max(...data);
   const min = Math.min(...data);
   const range = max - min || 1;
 
   const points = data
     .map((value, index) => {
       const x = (index / (data.length - 1)) * (width - 2 * padding) + padding;
       const y =
         height - padding - ((value - min) / range) * (height - 2 * padding);
       return `${x},${y}`;
     })
     .join(" ");
 
   return (
     <svg
       width="100%"
       height="60"
       viewBox={`0 0 ${width} ${height}`}
       className="overflow-visible"
     >
       {/* Background area */}
       <defs>
         <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
           <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.3" />
           <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.1" />
         </linearGradient>
       </defs>
       <path
         d={`M ${padding},${height - padding} L ${points} L ${width - padding},${
           height - padding
         } Z`}
         fill="url(#gradient)"
       />
       {/* Line */}
       <polyline
         points={points}
         fill="none"
         stroke="#3b82f6"
         strokeWidth="2"
         className="drop-shadow-sm"
       />
     </svg>
   );
 };